function getSaler(callback) {
  let url = "https://xt-sale.betatechgroup.com/getSale";

  $.ajax({
    type: "get",
    url,
    dataType: "json",
    success: callback,
  });
}


// 判断上次保存是否超过24小时
function isOver24Hours(lastsale, newtime){
  if(!lastsale){
    return false
  }
  const {lasttime}=lastsale
  const hours_24 = 24 * 60 * 60 * 1000; // 24小时的毫秒数
  // const hours_24 = 24 *  1000; // 24秒
  const diff = newtime - lasttime
  if(diff > hours_24){
    return true
  }
  return false
}

// 超过24小时才保存新销售
function setSaler(obj) {
  console.log("setSaler ===>", obj);
  if (!obj) {
    return;
  }
  const saler_xtw = localStorage.getItem("lastsaler_xtw");
  try {
    const latesttime = new Date().getTime()
    const last_saler = JSON.parse(saler_xtw)
    if(!isOver24Hours(last_saler,latesttime)){
      return 
    }
    const { sales, code } = obj.data || {};
    if (code === 200 && sales) {
      const newsaler = JSON.stringify({sales,lasttime:latesttime})
      localStorage.setItem("lastsaler_xtw",newsaler );
    }
  } catch (error) {
    console.log(error)
  }
  
}

// 上传图片
async function onUpload(e) {
  const file = e.files[0];
  if (!file) {
    return;
  }
  const uploadWrap = $("#contact-upload");
  const picWrap = $(".ymq_upload_file_item");
  const picImg = picWrap.find("img");
  const uploadLabel = $(".ymq_upload_new");
  uploadLabel.addClass("ymq-btn-progress");

  const client = new OSS({
    region: "oss-us-west-1", //你的oss地址 ，具体位置见下图
    accessKeyId: "LTAI5tC7havbcJhq4GdqLFcn", //你的ak
    accessKeySecret: "3gT45QLbmqgxHUKidtD4Gj0h6ArFqK", //你的secret
    //stsToken: '<Your securityToken(STS)>',//这里我暂时没用，注销掉
    bucket: "cikersbaseball", //你的oss名字
    secure: true,
  });

  const filename =
    "logo" + new Date().getTime() + Math.round(Math.random() * 1000);
  const res = await client.put(filename, file);
  const url = res?.url;
  uploadWrap.val(url);
  picImg.attr("src", url);
  picWrap.show();
  uploadLabel.addClass("ymq_disabled");
  uploadLabel.removeClass("ymq-btn-progress");
  uploadLabel.find("input").attr("disabled", true);
  $("#upload_del").on("click", delUpload);
}

function delUpload() {
  console.log("111=>delUpload");
  const uploadWrap = $("#contact-upload");
  const picWrap = $(".ymq_upload_file_item");
  const picImg = picWrap.find("img");
  const uploadLabel = $(".ymq_upload_new");

  uploadWrap.val("");
  picImg.removeAttr("src");
  picWrap.hide();
  uploadLabel.removeClass("ymq_disabled");
  uploadLabel.find("input").removeAttr("disabled").val("");
}

function initTeamColor() {
  console.log("initTeamColor ==>", 111);
  let result = {};
  $(".checkbox_input").on("click", function () {
    const id = $(this).attr("id");
    const val = $(this).val();
    if (!result[id]) {
      result[id] = val;
    } else {
      result[id] = "";
    }
    const values = Object.values(result).filter((item) => item);
    $("#ContactForm #TeamColor").val(values.join(","));
    console.log("initTeamColor result values==>", result, values);
  });
}
 
// 这里是 formspree
const saleman_action = {
  Fuson: "https://formspree.io/f/mzbowqqp",
  Shirley: "https://formspree.io/f/xbjwzorr",
  jimmy: "https://formspree.io/f/xrgrazla",
  ShirleyZ: "https://formspree.io/f/mzbkpepr",
  Mia: "https://formspree.io/f/manyypao",
  Leo: "https://formspree.io/f/mdkogelv",
  Iris: "https://formspree.io/f/xgedlnjq",
  Ze: "https://formspree.io/f/mdkgkpng",
  Lily: "https://formspree.io/f/xlgobgpa",
  Mariia: "https://formspree.io/f/xkopybpq",
  Lucas: "https://formspree.io/f/mdabnvka",
};
// 这里是 WhatsApp
const saleman_what_no = {
  Fuson: "8615820233193",
  //Shirley: "8615169990690",
  jimmy: "8613640280322",
  ShirleyZ: "85294239727",
  //Mia: "8617798578229",
  //Leo: "8617813324969",
  Iris: "8615137818380",
  //Ze: "85246214656",
};

function handleWhats() {
  const saler = localStorage.getItem("saler_xtw");
  let numbers = saleman_what_no[saler];
  let whaturl = "https://wa.me/" + numbers;
  let whatapi = "https://api.whatsapp.com/send?phone=" + numbers;
  // window.open(whaturl);
  // setTimeout(function () {
  window.open(whatapi);
  // }, 2000)
}

function openWhats() {
  // fbq("track", "Contact");
  handleWhats();
}

const numberReg = /^\d{9,}$/;

function scrollFormTop() {
  const contactform = document.getElementById("formtop");
  contactform.scrollIntoView();
}

function checkForm() {
  const name = $(".contact-form__form input[name='Name']");
  const email = $(".contact-form__form input[name='email']");
  // const phone = $(".contact-form__form input[name='Phone']");
  const whatsApp = $(".contact-form__form input[name='whatsapp/phone']");
  const errorTip = $("#error-tip");
  const errorWrap = $(".form-error-status");
 
  if (!email.val()) {
    errorWrap.show();
    errorTip.html("email is invalid!");
    // errorTip.attr("href", "#ContactForm-email");
    scrollFormTop();
    return false;
  }
 
  if (whatsApp && !whatsApp.val()) {
    errorWrap.show();
    errorTip.html("WhatsApp/Phone is invalid!");
    // errorTip.attr("href", "#ContactForm-whatsApp");
    scrollFormTop();
    return false;
  }

  return true;
}

function btnloading(flag) {
  const btn = $("#contact_submit");
  if (flag) {
    btn.addClass("loading");
  } else {
    btn.removeClass("loading");
  }
}

function initFormTime(){

  const query_time= Date.now()
   const contactform = $(".contact-form__form");
  console.log('query_time ===>',query_time)
  contactform.find("input[name='query_time']").val(query_time);
}

/* 如果地址中包含utm_source=facebook 则 为ad_source 文本框赋值 & ad_id=xxxx */
function initFormAd(){
  const ad_URL = location.href;
  const tags =  'utm_source=facebook&'
  console.log('ad_source 111==>',ad_URL)
  if (ad_URL.indexOf("ad_id") > -1 && ad_URL.indexOf(tags)>-1 ) {
    const adInfo = ad_URL.split(tags)
    console.log('ad_source 222==>',adInfo)
    if(adInfo.length){
      const adSource = adInfo[1].replace('&', ' ')
       $("#ad_source").val(adSource);
    }
  } else{
      $("#ad_source").val(ad_URL);
    }
}

function getNewSaler(){
  let lastsaler = localStorage.getItem('lastsaler_xtw')
  try {
    lastsaler = JSON.parse(lastsaler) || {}
  } catch (error) {
    lastsaler = {}
  }
  return lastsaler.saler
}

// data 销售名称
// 初始化时表单action地址为销售询盘地址
// 初始化广告来源 location.href
function initFormAction(data) {
  const { sales, code,adSaler } = data.data || {}; 

  const last_saler = getNewSaler()
  const newsaler = adSaler || last_saler || sales
  console.log('adSaler ===>',adSaler)
  const action =  saleman_action[newsaler] 
  const submitbtn = document.getElementById("contact_submit");
  const firstcolor = document.getElementById("Sports1")
  if (!action) {
    return;
  }
  if(firstcolor){
    firstcolor.click()
  }
  const contactform = $(".contact-form__form");
  contactform.find("input[name='form_type']").val('v2022');
  contactform.find("input[name='utf8']").remove();
  contactform.find("input[name='form_key']").remove();
  
  let loading = false
  $(submitbtn).on("click", function (e) {
    e.preventDefault();
    btnloading(true);
     if(loading){
      return 
    }
    const isvalid = checkForm();
    if (!isvalid) {
      loading=false
      btnloading(false);
      return;
    }
    loading=true
    const username = contactform.find("input[name='Name'").val()
    const email = contactform.find("input[name='email'").val()
    const time = new Date().toLocaleString()
  const news_subject = `${username}_${email}_${time}`
  $('#mail_subject').val(news_subject)
    // handleBackup(contactform[0]);
    handleWeixinLog(contactform[0],newsaler,(res)=>{
      console.log('handleWeixinLog ==>res',res)
       contactform.attr("action", action);
        
        contactform.submit();
    })
   
  });
}



function getAdsaler(adId){
  const adUrl = location.href
  if(adUrl.indexOf('120241871107720591')>-1){
    return 'Lucas'
  }
  return false
}

//  Lucas: "https://formspree.io/f/mdabnvka"
// 广告ID：120241871107720591
// 来自此广告的询盘都 分配给Lucas

function initSaler(data) {
  const adSaler = getAdsaler('120241871107720591')
  if(adSaler){
    data.data.adSaler = adSaler
  } 

  setSaler(data);
  initFormAd()
  initFormTime()
  initFormAction(data);
}

$(document).ready(function () {
  initTeamColor();
  getSaler(initSaler);
});
